import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import cn from 'classnames';

var _excluded = ["delay", "label"];
var Spinner = /*#__PURE__*/React__default.forwardRef(function Spinner(props, ref) {
  var _props$delay = props.delay,
      delay = _props$delay === void 0 ? 500 : _props$delay,
      label = props.label,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var _React$useState = React__default.useState(!delay),
      visible = _React$useState[0],
      setVisibility = _React$useState[1];

  React__default.useEffect(function () {
    var timeout;

    if (delay) {
      timeout = window.setTimeout(function () {
        return setVisibility(true);
      }, delay);
    }

    return function () {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [delay]);

  if (!visible) {
    return null;
  }

  var className = cn('yt-spinner', otherProps.className);
  return React__default.createElement("div", Object.assign({}, otherProps, {
    className: className,
    ref: ref
  }), React__default.createElement("svg", {
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "45"
  })), label && React__default.createElement("span", null, label));
});

export { Spinner };
//# sourceMappingURL=Spinner.js.map
